<template>
  <b-container fluid>
    <div class="page-header">
      <Navbar text="Account Settings" />
    </div>

    <div class="card">
      <div class="subscription-header">
        <h1>Subscription Options</h1>
        <h2>
          Ready to take it to the next level with Harpra? Choose the plan that suits your needs.
        </h2>
      </div>

      <div class="pricingTable">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              v-bind:class="{ active: isYearlyActive }"
              data-toggle="tab"
              href="#"
              @click="changeTab('Y')"
              role="tab"
              aria-controls="yearly"
              aria-selected="false"
            >
              Yearly <span class="small">Save 17%</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              v-bind:class="{ active: !isYearlyActive }"
              data-toggle="tab"
              href="#"
              @click="changeTab('M')"
              role="tab"
              aria-controls="monthly"
              aria-selected="false"
            >
              Monthly
            </a>
          </li>
        </ul>

        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="yearly"
            v-if="isYearlyActive"
            role="tabpanel"
            aria-labelledby="yearly-tab"
          >
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <span class="text-uppercase">Professional</span>
                      | $1500/year
                    </th>
                    <th>
                      <span class="text-uppercase">Business</span>
                      | $4260/year
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                    <td>Ideal for Individuals, Teams or Single Business Units</td>
                    <td>Ideal for Company-wide Deployment</td>
                  </tr>
                  <tr>
                    <td class="h2">Client Web Portal</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Digital Asset Management</td>
                    <td><span class="icon icon-check"></span></td>
                    <td><span class="icon icon-check"></span></td>
                  </tr>
                  <tr>
                    <td class="h2">Harpra Mixed Reality Viewer</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Storage Slots</td>
                    <td>12 Storage Slots</td>
                    <td>40 Storage Slots</td>
                  </tr>
                  <tr>
                    <td>Active Models</td>
                    <td>4 Active Models</td>
                    <td>20 Active Models</td>
                  </tr>
                  <tr>
                    <td>Review Module</td>
                    <td><span class="icon icon-check"></span></td>
                    <td><span class="icon icon-check"></span></td>
                  </tr>
                  <tr>
                    <td>Animate Module</td>
                    <td><span class="icon icon-check"></span></td>
                    <td><span class="icon icon-check"></span></td>
                  </tr>
                  <tr>
                    <td class="h2">Harpra Companion App</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Model Slots</td>
                    <td>12 Model Slots</td>
                    <td>40 Model Slots</td>
                  </tr>
                  <tr>
                    <td>Brochure Slots</td>
                    <td>3 Brochure Slots</td>
                    <td>12 Brochure Slots</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <a href="#" class="btn btn-red" @click="checkout('YP')">
                        Buy Now
                      </a>
                    </td>
                    <td>
                      <a href="#" class="btn btn-red" @click="checkout('YB')">
                        Buy Now
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            class="tab-pane fade show active"
            id="monthly"
            v-if="!isYearlyActive"
            role="tabpanel"
          >
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <span class="text-uppercase">Professional</span>
                      | $150/month
                    </th>
                    <th>
                      <span class="text-uppercase">Business</span>
                      | $425/month
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                    <td>Ideal for Individuals, Teams or Single Business Units</td>
                    <td>Ideal for Company-wide Deployment</td>
                  </tr>
                  <tr>
                    <td class="h2">Client Web Portal</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Digital Asset Management</td>
                    <td><span class="icon icon-check"></span></td>
                    <td><span class="icon icon-check"></span></td>
                  </tr>
                  <tr>
                    <td class="h2">Harpra Mixed Reality Viewer</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Storage Slots</td>
                    <td>12 Storage Slots</td>
                    <td>40 Storage Slots</td>
                  </tr>
                  <tr>
                    <td>Active Models</td>
                    <td>4 Active Models</td>
                    <td>20 Active Models</td>
                  </tr>
                  <tr>
                    <td>Review Module</td>
                    <td><span class="icon icon-check"></span></td>
                    <td><span class="icon icon-check"></span></td>
                  </tr>
                  <tr>
                    <td>Animate Module</td>
                    <td><span class="icon icon-check"></span></td>
                    <td><span class="icon icon-check"></span></td>
                  </tr>
                  <tr>
                    <td class="h2">Harpra Companion App</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Model Slots</td>
                    <td>12 Model Slots</td>
                    <td>40 Model Slots</td>
                  </tr>
                  <tr>
                    <td>Brochure Slots</td>
                    <td>3 Brochure Slots</td>
                    <td>12 Brochure Slots</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <a href="#" class="btn btn-red" @click="checkout('MP')">
                        Buy Now
                      </a>
                    </td>
                    <td>
                      <a href="#" class="btn btn-red" @click="checkout('MB')">
                        Buy Now
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import Navbar from "../Navigation/Navbar";
import config from "../../config/stripe.config";

export default {
  name: "Checkout",
  components: {
    Navbar,
  },
  data() {
    return {
      isYearlyActive: true,
    };
  },
  methods: {
    changeTab(type, sender) {
      this.isYearlyActive = type == "Y" ? true : false;
    },
    checkout(type) {
      if (type != "MP" && type != "YP" && type != "MB" && type != "YB") {
        return;
      }

      var stripe = Stripe(config.stripeSecret);
      var plan = config.plan[type];

      var user = this.$AuthService.getUser();

      if (user.email === undefined || user.email === "") {
        return;
      }

      stripe
        .redirectToCheckout({
          items: [{ plan: plan, quantity: 1 }],
          successUrl: config.returnSuccess,
          cancelUrl: config.returnFailure,
          customerEmail: user.email,
        })
        .then(function (result) {
          if (result.error) {
            var displayError = document.getElementById("error-message");
            displayError.textContent = result.error.message;
          }
        });
    },
  },
  mounted() {
    let stripeScript = document.createElement("script");
    stripeScript.setAttribute("src", "https://js.stripe.com/v3");
    document.head.appendChild(stripeScript);
  },
};
</script>
